import { operationGatewayInterface } from '../../../corelogic/usecases/operation/operationGatewayInterface';
import { defaultTheme } from '../../../config/app-config';

export default class InMemoryOperationGateway implements operationGatewayInterface {
  error: any;

  constructor() {}

  setError = (error: boolean) => {
    this.error = error;
  };

  getOrganizerByJwt = () => {
    return {
      id: 1,
      name: 'test',
      userId: 1,
    };
  };

  getOperations = (ids: any) => {
    return Promise.resolve([
      {
        id: ids,
      },
    ]);
  };
  getObserverOperations = () => {
    return [
      {
        id: 1,
      },
    ];
  };

  getOrganizerOperations = (organizerId: any) => {
    return [
      {
        id: 1,
      },
    ];
  };

  getParticipantsByJwt(): any[] {
    return [
      {
        id: 1,
        name: 'Denis Brogniart',
        userId: 1,
        operationId: 1,
      },
      {
        id: 2,
        name: 'participant2',
        userId: 1,
        operationId: 1,
      },
      {
        id: 3,
        name: 'participant3',
        userId: 1,
        operationId: 1,
      },
      {
        id: 4,
        name: 'participant4',
        userId: 1,
        operationId: 2,
      },
      {
        id: 5,
        name: 'participant5',
        userId: 1,
        operationId: 2,
      },
      {
        id: 6,
        name: 'participant6',
        userId: 1,
        operationId: 2,
      },
    ];
  }

  getOperationParticipants = (operationId: number) => {
    return [
      {
        _id: 1,
        _name: 'participant1',
        _userId: 1,
        _operationId: operationId,
      },
      {
        _id: 2,
        _name: 'participant2',
        _userId: 1,
        _operationId: operationId,
      },
      {
        _id: 3,
        _name: 'participant3',
        _userId: 1,
        _operationId: operationId,
      },
    ];
  };

  getOperationObservers = (operationId: number) => {
    return [
      {
        id: 1,
        name: 'observer name',
        userId: 1,
        operationId: operationId,
      },
    ];
  };

  getPresignedLogo(operation: any): any {}

  updateOperation(operation: any): any {}

  uploadLogo(operation: any, formData: any): any {}

  getOperationInfos(
    operationId: number,
    latestDayWithDataAvailable: string,
  ): Promise<{ consumers: number; producers: number; powerExchanged: number }> {
    switch (operationId) {
      case 1:
        return Promise.resolve({
          consumers: 8,
          producers: 13,
          powerExchanged: 687,
        });
      default:
        return Promise.resolve({
          consumers: 4,
          producers: 1,
          powerExchanged: 89,
        });
    }
  }

  getParticipantOperation(operationId: number): Promise<any> {
    switch (operationId) {
      case 1:
        return Promise.resolve({
          id: 1,
          enedisId: 'ACC00000005',
          name: 'Malaunay',
          theme: defaultTheme,

          // option 1 : dso: "SIBELGA", legalRegion: "BRUXELLES",
          // dso: "SIBELGA",
          // legalRegion: "BRUXELLES",
          // billingEngine: "ENGINE_2025",

          // option 2 : dso: "ENEDIS", legalRegion: "FRANCE",
          dso: 'ENEDIS',
          legalRegion: 'FRANCE',
          billingEngine: 'ENGINE_2025',
        });
      case 2:
        return Promise.resolve({
          id: 2,
          enedisId: 'ACC000000012',
          name: 'Paul Ricard',
          theme: defaultTheme,

          // option 1 : dso: "SIBELGA", legalRegion: "BRUXELLES",
          // dso: "SIBELGA",
          // legalRegion: "BRUXELLES",
          // billingEngine: "ENGINE_2025",

          // option 2 : dso: "ENEDIS", legalRegion: "FRANCE",
          dso: 'ENEDIS',
          legalRegion: 'FRANCE',
          billingEngine: 'ENGINE_2025',
        });
      default:
        return Promise.resolve({
          id: 1,
          enedisId: 'ACC00000005',
          name: 'Malaunay',
          theme: defaultTheme,
          dso: 'ENEDIS',
          legalRegion: 'FRANCE',
          billingEngine: 'ENGINE_2025',
        });
    }
  }

  getLatestDateWithData(operationId: number): any {
    return {
      latestDay: '30/06/2022',
    };
  }
}
